import angular = require('angular');
import { PopupService } from '../../../../../../app.common/modules/common/services/popup.service';

class ProductStickersList implements ng.IController {
    public static $inject = ['$translate', 'popupService'];
    public items: any[];
    public stores: any[];
    public errors: any[];
    public storesDic: any;
    public pattern = '[A-Z]{1}\\d{12}$';
    public hidePosition: boolean;
    private stickerListForm: angular.IFormController;

    constructor(
        protected $translate: angular.translate.ITranslateService,
        private popupService: PopupService,
    ) {
    }

    public $onInit(): void {
        this.items = [];
        this.stores = [];
    }

    public deleteStickerItem = async (itemIndex: any) => {
        try {
            await this.popupService.confirm({
                okClass: 'btn btn-with-icon btn-with-icon--before-close color-black54 bg-dark12',
                okTxt: this.$translate.instant('delete_sticker_dialog_content_cancel'),
                cancelClass: 'btn btn-with-icon btn-with-icon--before-confirm btn-success',
                cancelTxt: this.$translate.instant('delete_sticker_dialog_content_ok'),
                classPopup: 'alert--redesign modal360',
                title: this.$translate.instant('delete_sticker_dialog_title'),
                content: this.$translate.instant('delete_sticker_dialog_content'),
                invertAction: true
            });
        } catch (e) {
            return;
        }

        this.items.splice(itemIndex, 1);
        this.stickerListForm.$setDirty();
    }

    public addStickerItem = () => {
        const newStickerItem = this.hidePosition ? { StickerNumber: null, PlaceID: null } : { StickerNumber: null, PlaceID: null, Position: null};
        this.items.push(newStickerItem);
    }
}

angular.module('naut').component('productStickersList', {
    template: require('./product-stickers-list.component.html'),
    controller: ProductStickersList,
    controllerAs: 'ctrl',
    bindings: {
        items: '=',
        stores: '<',
        hidePosition: '<',
        isListDisabled: '<',
        errors: '<',
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/products/components/shared/product-stickers-list/product-stickers-list.component.ts